import PropTypes from 'prop-types';
import React from 'react';
import AsyncIcon from '@ux/icon/async-icon.js';

import NavigationLink from './NavigationLink';
import useIsMobile from '../lib/useIsMobile';

const SidebarFooter = ({ content = [], sidebarNavLinkHandler }) => {
  const isMobile = useIsMobile();
  return (<div className='sidebar-footer'>
    <div className='sidebar-links'>
      {
        content.map(link => {
          if (link.caption && link.href) {
            let linkLabel = link.caption;
            if (link.key === 'mcc:switchToClassicParking') {
              linkLabel = <div className='switch-message'>{ link.caption }<AsyncIcon icon='link-arrow' /></div>;
            }
            return <NavigationLink
              key={ link.caption }
              link={ link }
              sidebarNavLinkHandler={ sidebarNavLinkHandler }
              className='sidebar-nav-link'>
              <>
                <span className='nav-link-icon'>{ (!isMobile && link.icon) ? <AsyncIcon icon={ link.icon } /> : <span /> }</span>
                <span className='nav-link-label'>{ linkLabel }</span>
              </>
            </NavigationLink>;
          }
          return null;
        })
      }
    </div>
  </div>);
};

SidebarFooter.propTypes = {
  content: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  sidebarNavLinkHandler: PropTypes.func
};

export default SidebarFooter;
